import React from 'react';
import Button from "../button";
import './index.css';

function ButtonWithIcon (props) {

    const {className, children, ...other} = props;

    return (
        <Button className={className ? `button-with-icon ${className}` : 'button-with-icon'} {...other}>
            { children }
        </Button>
    )
}

export default ButtonWithIcon;